'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cleanObject = exports.isEmpty = exports.isNumeric = exports.camelToLabel = undefined;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _validator = require('validator');

var _validator2 = _interopRequireDefault(_validator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var camelToLabel = exports.camelToLabel = function camelToLabel(camelCase) {
  return camelCase.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) {
    return str.toUpperCase();
  });
};

var isNumeric = exports.isNumeric = function isNumeric(number) {
  if (typeof number !== 'string') throw new Error('isNumeric only accepts strings');
  return _validator2.default.isNumeric(number) || _validator2.default.isDecimal(number);
};

var isEmpty = exports.isEmpty = function isEmpty(value) {
  return value === null || value === undefined || typeof value === 'string' && value.trim() === '';
};

// Removes keys that have null or undefined values
var cleanObject = exports.cleanObject = function cleanObject(object) {
  return _lodash2.default.pickBy(object, function (prop) {
    return prop !== undefined && prop !== null;
  });
};